declare const angular: ng.IAngularStatic;
export class cartService {
    user = {
        UserID: 0
    }
    cartUrl;
    constructor(private localStorageService, private $notify, public $rootScope, private $mPath, private $user, private $order, private $q) {
        "ngInject"

        $mPath.get().then(
            response => {
                this.cartUrl = response.StoreCart + "/";
            }
        )
    }

    get(user) {
        user = user || { UserID: 0 }
        let obj = this.localStorageService.get(`user${user.UserID}`) || []
        return obj;
    }

    checkOrderStatus(user, orderId) {
        let itemToSend = [];
        let data = this.getByOrderId(user, orderId)
        data.salabelItems.map((item) => {
            itemToSend.push({
                BasePrice: item.BasePrice,
                FinalPrice: item.FinalPrice,
                Quantity: item.count,
                SalableItemID: item.SalableItemID,
                VendorID: data.VendorID
            })
        })
        return this.$order.checkStatus(itemToSend)
    }

    private getByOrderId(user, orderId) {
        let basket = this.get(user)
        let obj
        basket.map(item => {
            if (item.orderId == orderId) {
                obj = item
            }
        })
        return obj;
    }

    add(user, product, vendor, salabelItem) {
        
        user = user || { UserID: 0 }
        let obj = this.get(user)
        // let isExist = this.checkExist(obj, product, vendor, salabelItem)
        let vendorIndex = this.vendorIndex(obj, vendor)
        if (vendorIndex > -1) {
            let salabelIndex = this.salableIndex(obj, vendorIndex, salabelItem)
            if (salabelIndex > -1) {
                this.increaseCount(user, obj, vendorIndex, salabelIndex, salabelItem)
            }
            else {
                salabelItem.product = product;
                this.pushToVendor(user, obj, vendorIndex, salabelItem)
            }
        }
        else {
            salabelItem.product = product;
            vendor.salabelItems = [salabelItem]
            obj.push(vendor)

            this.localStorageService.set(`user${user.UserID}`, obj)
            this.$notify.action({ text: 'با موفقیت به سبد خرید شما اضافه شد.', action: "پرداخت و تکمیل سفارش", actionUrl: this.cartUrl, actionTarget: '_self' })
            this.$rootScope.$emit('cartChange')
        }
    }

    removeVendor(user, vendor) {
        user = user || { UserID: 0 }
        let obj = this.get(user)
        angular.forEach(obj, (val, key) => {
            if (val.VendorID === vendor.VendorID) {
                obj.splice(key, 1);
            }
        })
        this.localStorageService.set(`user${user.UserID}`, obj)
        this.$rootScope.$emit('cartChange')
    }

    removeOrder(user, orderId) {
        let obj = this.get(user);
        angular.forEach(obj, (val, key) => {
            if (val.orderId == orderId) {
                obj.splice(key, 1)
                this.localStorageService.set(`user${user.UserID}`, obj)
                this.$rootScope.$emit('cartChange')
            }
        })
    }

    moveCart(user) {
        let userCart = this.get(user)
        let guestCart = this.get({ UserID: 0 })
        guestCart.map(vendor => {
            let vendorIndex = this.vendorIndex(userCart, vendor)
            if (vendorIndex > -1) {
                vendor.salabelItems.map(item => {
                    let salabelIndex = this.salableIndex(userCart, vendorIndex, item)
                    if (salabelIndex > -1) {
                        userCart[vendorIndex].salabelItems[salabelIndex].count += item.count
                    }
                    else {
                        userCart[vendorIndex].salabelItems.push(item)
                    }
                })
            }
            else {
                userCart.push(vendor)
            }
        })
        guestCart = []
        this.localStorageService.set(`user${user.UserID}`, userCart)
        this.localStorageService.set(`user0`, guestCart)
        this.$rootScope.$emit('cartChange')
    }

    changeSalabelItem(user, vendor) {
        user = user || { UserID: 0 }
        let obj = this.get(user)
        angular.forEach(obj, (val, key) => {
            if (val.VendorID === vendor.VendorID) {
                obj[key] = vendor;
            }
        })
        this.localStorageService.set(`user${user.UserID}`, obj)
        this.$rootScope.$emit('cartChange')
    }

    setCheckOut(user, vendor) {
        let obj = this.get(user)
        let vendorIndex = this.vendorIndex(obj, vendor)
        let order = this.$order.getOrder(obj[vendorIndex].orderId)

        return this.$q((resolve, reject) => {
            let salabelItems = []
            vendor.salabelItems.map(item => {
                let options = []
                item.SaleOptions.map(opt => {
                    options.push({ SalableItemAttributeValID: opt.SaleOptionValues[0].ValID })

                })
                let salabelItem = {
                    "SalableItemID": item.SalableItemID,
                    "Quantity": item.count,
                    "SalableItemOptionAttributeValues": options
                }
                salabelItems.push(salabelItem)
            })
            if (order.OrderID) {
                order.SalableItems = salabelItems
            }
            else {
                order = {
                    "OrderID": obj[vendorIndex].orderId,
                    "VendorID": obj[vendorIndex].VendorID,
                    "SalableItems": salabelItems
                }
            }
            this.$order.setOrder(order).then(
                order => {
                    obj[vendorIndex].orderId = order[0].OrderID
                    this.localStorageService.set(`user${user.UserID}`, obj)
                    resolve(order[0].OrderID)
                },
                error => {
                    reject(error)
                }
            )
        })
    }

    private vendorIndex(obj, vendor) {
        let index = -1
        angular.forEach(obj, (val, key) => {
            if (val.VendorID == vendor.VendorID) {

                index = key
            }
        })
        return index;
    }

    private salableIndex(obj, vendorIndex, salabelItem) {
        let index = -1
        angular.forEach(obj[vendorIndex].salabelItems, (val, key) => {
            if (val.SalableItemID == salabelItem.SalableItemID) {
                if (angular.equals(val.$selectOptions, salabelItem.$selectOptions)) {
                    index = key
                }
            }
        })
        return index;
    }

    private removeItem(obj, product) {
        angular.forEach(obj, (val, key) => {
            if (val.ProductID === product.ProductID) {
                obj.splice(key, 1)
            }
        })
        return obj
    }

    private increaseCount(user, obj, vendorIndex, salabelItemIndex, salabelItem) {

        obj[vendorIndex].salabelItems[salabelItemIndex].count += salabelItem.count;
        this.localStorageService.set(`user${user.UserID}`, obj)
        this.$notify.action({ text: 'این محصول قبلا به سبد خرید شما اضافه شده بود. اکنون به تعداد آن اضافه شد. ', action: "پرداخت و تکمیل سفارش", actionUrl: this.cartUrl, actionTarget: '_self' })
        this.$rootScope.$emit('cartChange')
    }

    private pushToVendor(user, obj, vendorIndex, salabelItem) {
        obj[vendorIndex].salabelItems.push(salabelItem)
        this.localStorageService.set(`user${user.UserID}`, obj)
        this.$notify.action({ text: 'با موفقیت به سبد خرید شما اضافه شد.', action: "پرداخت و تکمیل سفارش", actionUrl: this.cartUrl, actionTarget: '_self' })
        this.$rootScope.$emit('cartChange')
    }
}


// WEBPACK FOOTER //
// ./src/services/cart/cart.ts